module.exports = __webpack_public_path__ + "img/p4_4.698edb41.png";